import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


function CreditorDebitorReport() {
    const { isAuthenticated, companyId, branchId, permissions, companyName, token, username, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        fetchTableData();

    }, [isAuthenticated, companyId, branchId, permissions, token, logout]);

    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]); // Default to today's date
    const [isFocused, setIsFocused] = useState(false);

    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const hasReadReportPermission = permissions.includes('Read Reports');

    // Function to format date as dd/mm/yyyy
    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add leading zero, months are 0-indexed
        const year = today.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value); // Ensure `toDate` is updated
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const [totalcls, setTotalcls] = useState(0);

    useEffect(() => {
        let totalcls = 0;

        data.forEach(item => {
            totalcls += item.amount;

        });
        setTotalcls(totalcls);
    }, [data]);

    const [debitororcreditorType, setdebitororcreditor] = useState("1");
    const handlesetdebitororcreditorTypeChange = (event) => {
        setdebitororcreditor(event.target.value);
    };

    const [loading, setLoading] = useState(false);


    const fetchTableData = async () => {
        if (!toDate) {
            console.error('To Date is required!');
            return;
        }

        if (hasReadReportPermission) {
            setData([]);
            setLoading(true);
            try {
                const url = `/${toDate}/${companyId}/${companyId}/${companyId}/${companyId}/${companyId}/${debitororcreditorType}`;
                //console.log('Constructed URL:', url);
                const response = await fetchData('ReportApi', url, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Stock Details:', error);
            } finally {
                setLoading(false);
            }
        }
    };


    // const handleExportExcel = async () => {
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet(
    //         debitororcreditorType === "1" ? "Creditors List" : "Debtors List"
    //     );

    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
    //     const title = `${companyName} - ${debitororcreditorType === "1" ? "Creditors List" : "Debtors List"}:  To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By: ${username}`;

    //     // 🟦 Title Row (merged across columns A-C)
    //     worksheet.mergeCells('A1:C1');
    //     const titleCell = worksheet.getCell('A1');
    //     titleCell.value = title;
    //     titleCell.font = { bold: true, size: 9 };
    //     titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
    //     titleCell.fill = {
    //         type: 'pattern',
    //         pattern: 'solid',
    //         fgColor: { argb: 'FFDDEEFF' }
    //     };

    //     // 🟩 Header Row
    //     const headerRow = worksheet.addRow(['Name', 'Contact No', 'Amount']);
    //     headerRow.eachCell((cell) => {
    //         cell.font = { bold: true };
    //         cell.alignment = { horizontal: 'center' };
    //         cell.fill = {
    //             type: 'pattern',
    //             pattern: 'solid',
    //             fgColor: { argb: 'FFCCE5FF' }, // light blue
    //         };
    //         cell.border = {
    //             top: { style: 'thin' },
    //             left: { style: 'thin' },
    //             bottom: { style: 'thin' },
    //             right: { style: 'thin' },
    //         };
    //     });

    //     // 🟨 Add Data Rows (with borders + alignment + special Total highlight)
    //     filteredData.forEach((rowData) => {
    //         const row = worksheet.addRow([
    //             rowData.name,
    //             rowData.Contactno,
    //             parseFloat(rowData.amount.toFixed(2))
    //         ]);

    //         row.eachCell((cell, colNumber) => {
    //             cell.border = {
    //                 top: { style: 'thin' },
    //                 left: { style: 'thin' },
    //                 bottom: { style: 'thin' },
    //                 right: { style: 'thin' },
    //             };

    //             // 🔹 Right align only Amount column
    //             if (colNumber === 3) {
    //                 cell.alignment = { horizontal: 'right' };
    //             }

    //             // 🔹 If this is the "Total" row, highlight entire row
    //             if (rowData.name?.toLowerCase() === "total") {
    //                 cell.font = { bold: true };
    //                 cell.fill = {
    //                     type: 'pattern',
    //                     pattern: 'solid',
    //                     fgColor: { argb: 'FFFFE699' }, // light yellow
    //                 };
    //             }
    //         });
    //     });

    //     // 📝 Adjust Column Widths
    //     worksheet.columns = [
    //         { key: 'name', width: 30 },
    //         { key: 'contact', width: 25 },
    //         { key: 'amount', width: 15 },
    //     ];

    //     // 📁 Generate file
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const fileName = `$${debitororcreditorType === "1" ? "Creditors List" : "Debtors List"}_${formatDate(toDate).replace(/\//g, '-')}.xlsx`;
    //     saveAs(new Blob([buffer]), fileName);
    // };
    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(
            debitororcreditorType === "1" ? "Creditors List" : "Debtors List"
        );

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const title = `${companyName} - ${debitororcreditorType === "1" ? "Creditors List" : "Debtors List"}:  To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By: ${username}`;

        // 🟦 Title Row (merged across columns A-C)
        worksheet.mergeCells('A1:C1');
        const titleCell = worksheet.getCell('A1');
        titleCell.value = title;
        titleCell.font = { bold: true, size: 9 };
        titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
        titleCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFDDEEFF' }
        };

        // 🟩 Header Row
        const headerRow = worksheet.addRow(['Name', 'Contact No', 'Amount']);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFCCE5FF' }, // light blue
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        // 🟨 Add Data Rows (with borders + alignment + special Total highlight)
        filteredData.forEach((rowData) => {
            const row = worksheet.addRow([
                rowData.name,
                rowData.Contactno,
                parseFloat(rowData.amount.toFixed(2))
            ]);

            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };

                // 🔹 Right align only Amount column
                if (colNumber === 3) {
                    cell.alignment = { horizontal: 'right' };
                }

                // 🔹 If this is the "Total" row, highlight entire row
                if (rowData.name?.toLowerCase() === "total") {
                    cell.font = { bold: true };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFE699' }, // light yellow
                    };
                }
            });
        });


        // 📝 Adjust Column Widths
        worksheet.columns = [
            { key: 'name', width: 30 },
            { key: 'contact', width: 25 },
            { key: 'amount', width: 15 },
        ];

        // 📁 Generate file
        const buffer = await workbook.xlsx.writeBuffer();
        const fileName = `$${debitororcreditorType === "1" ? "Creditors List" : "Debtors List"}_${formatDate(toDate).replace(/\//g, '-')}.xlsx`;
        saveAs(new Blob([buffer]), fileName);
    };



    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };


    const processedData = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    return (


        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '-1%' }}>
            <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                {/* Title */}
                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                >
                    {debitororcreditorType === "1" ? "CREDITORS LIST" : "DEBITORS LIST"}
                </h6>

                {/* 🔹 Filters & Buttons */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "18px",
                    }}
                >
                    {/* Date Filter */}
                    <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: '16px', marginLeft: '2px', marginTop: '1.25%' }}>
                        <div style={{ flex: '2', maxWidth: '150px', marginLeft: '8px', marginBottom: '0', marginTop: '-15px' }}>
                            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="toDate">
                                To Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                type="date" value={toDate} onChange={handleToDateChange} style={{ fontSize: '12.5px' }}
                            />
                        </div>
                    </div>

                    {/* Radio Buttons */}
                    <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                        <label style={{ fontSize: "13px" }}>
                            <input
                                type="radio"
                                name="debitororcreditorType"
                                value="1"
                                checked={debitororcreditorType === "1"}
                                onChange={handlesetdebitororcreditorTypeChange}
                            />
                            <span style={{ color: "#2563eb", marginLeft: "6px" }}>Creditors</span>
                        </label>

                        <label style={{ fontSize: "13px" }}>
                            <input
                                type="radio"
                                name="debitororcreditorType"
                                value="2"
                                checked={debitororcreditorType === "2"}
                                onChange={handlesetdebitororcreditorTypeChange}
                            />
                            <span style={{ color: "#b91c1c", marginLeft: "6px" }}>Debitors</span>
                        </label>
                    </div>

                    {/* Action Buttons */}
                    <div style={{ display: "flex", gap: "10px" }}>
                        <Button
                            onClick={fetchTableData}
                            style={{
                                background: "#475569",
                                color: "white",
                                borderRadius: "6px",
                                padding: "5px 14px",
                                fontSize: "13px",
                                fontWeight: "bold",
                                height: "30px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                            }}
                        >
                            Refresh
                        </Button>

                        <Button
                            onClick={handleExportExcel}
                            style={{
                                background: "#0f766e",
                                color: "white",
                                borderRadius: "6px",
                                padding: "5px 14px",
                                fontSize: "13px",
                                fontWeight: "bold",
                                height: "30px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                            }}
                        >
                            Excel
                        </Button>
                    </div>
                </div>
            </div>

            {/* Watermark */}
            <div
                className="watermark"
                style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "20px",
                    opacity: 0.7,
                    fontSize: "12px",
                }}
            >
                <CopyrightIcon fontSize="small" />
                <b style={{ fontFamily: "Script MT Bold, cursive", marginLeft: "3px" }}>
                    EFFTABS SOLUTIONS LLP
                </b>
            </div>

            {/* 🔹 Table Section */}
            <div
                className="w-full mb-5 flex"
                style={{
                    maxHeight: "520px",
                    overflowY: "auto",
                    marginTop: "8px",
                    borderRadius: "10px",
                }}
            >

                <TableContainer component={Paper} sx={{ boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#2E3B33' }}>
                            <TableRow>
                                {["NAME", "CONTACT", "AMOUNT"].map((col) => (
                                    <TableCell
                                        key={col}
                                        sx={{
                                            color: 'black',
                                            fontWeight: 'bold',
                                            fontSize: '11px',
                                            textTransform: 'uppercase',
                                            padding: '3px',
                                            borderBottom: 'none',
                                            backgroundColor: '#edf1efff'
                                        }}
                                        align={col === "AMOUNT" ? "right" : "left"}
                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody>
                            {processedData.length > 0 ? (
                                processedData.map((data, index) => (
                                    <TableRow
                                        key={data.id || index}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? "#f8fafc" : "#ffffff",
                                            "&:hover": { backgroundColor: "#e2efff" },
                                            transition: "background-color 0.2s ease-in-out",
                                        }}
                                    >
                                        <TableCell
                                            sx={{
                                                fontSize: "12.5px",
                                                color: "#1e293b",
                                                padding: "8px 10px",
                                            }}
                                        >
                                            {data.name}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontSize: "12.5px",
                                                color: "#475569",
                                                padding: "8px 10px",
                                            }}
                                        >
                                            {data.Contactno}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontSize: "12.5px",
                                                color: "#0f172a",
                                                padding: "8px 10px",
                                                textAlign: "right",
                                                fontWeight: 600,
                                            }}
                                        >
                                            {parseFloat(data.amount || 0).toFixed(2)}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell
                                        colSpan={3}
                                        align="center"
                                        sx={{
                                            color: "#64748b",
                                            padding: "16px",
                                            fontSize: "12.5px",
                                            backgroundColor: "#f8fafc",
                                            fontStyle: "italic",
                                        }}
                                    >
                                        No data available
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>

                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={filteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default CreditorDebitorReport;